var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "createSmallInstitution"
  }, [_c('init-header', {
    staticClass: "init-header",
    staticStyle: {
      "width": "calc(100% + 40px)",
      "margin-left": "-20px"
    },
    attrs: {
      "goBack": _vm.prev,
      "removeClose": true,
      "disabled": _vm.progressStep > 1 ? false : true
    }
  }), _c('progress-question', {
    attrs: {
      "progressStep": _vm.progressStep,
      "groupName": _vm.createParams.groupName
    }
  }), _vm.progressStep === 1 ? _c('progress-input-step1', {
    attrs: {
      "placeholder": _vm.tt(_vm.placeholder),
      "validText": _vm.tt(_vm.validText),
      "isValid": _vm.isValid
    },
    model: {
      value: _vm.createParams.instituteName,
      callback: function ($$v) {
        _vm.$set(_vm.createParams, "instituteName", $$v);
      },
      expression: "createParams.instituteName"
    }
  }) : _vm.progressStep === 2 ? _c('progress-input-step2', {
    attrs: {
      "placeholder": _vm.tt(_vm.placeholder),
      "validText": _vm.tt(_vm.validText),
      "isValid": _vm.isValid
    },
    model: {
      value: _vm.createParams.groupName,
      callback: function ($$v) {
        _vm.$set(_vm.createParams, "groupName", $$v);
      },
      expression: "createParams.groupName"
    }
  }) : _vm.progressStep === 3 ? _c('progress-input-step3', {
    attrs: {
      "storagesName": _vm.createParams.storagesName,
      "placeholder": _vm.tt(_vm.placeholder)
    },
    on: {
      "updateStorage": _vm.updateStorage,
      "clickDeleteStorage": _vm.clickDeleteStorage
    }
  }) : _vm._e(), _c('button', {
    staticClass: "next",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.tt(_vm.nextBtn)))])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }